import axios from "axios"
import { buyOrderListFail, buyOrderListRequest, buyOrderListSuccess, confirmedOrderListFail, confirmedOrderListRequest, confirmedOrderListSuccess, orderDetailFail, orderDetailRequest, orderDetailSuccess, updateOrderFail, updateOrderRequest, updateOrderSuccess, orderReset } from "../reducers/orderReducers"

// Function to get CSRF token from cookie
const getCsrfToken = () => {
    const name = 'csrftoken';
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

const createAPIinstance = () => {
    const csrfToken = getCsrfToken();
    return axios.create({
        baseURL: `${process.env.REACT_APP_BASE_API_URL}/api/users/orders`,
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': csrfToken
        },
        withCredentials: true
    })
}


export const buyList = () => async (dispatch) => {

    try {
        dispatch(buyOrderListRequest())

        const api = createAPIinstance()
        const { data } = await api.get('/buying/')

        dispatch(buyOrderListSuccess(data))
    } catch (error) {
        dispatch(buyOrderListFail(
            error.response && error.response.data.detail ?
            error.response.data.detail :
            error.message
        ))
    }

}


export const updateOrder = (orderID, updatedData) => async (dispatch) => {
    try {
        dispatch(updateOrderRequest())

        const api = createAPIinstance()

        const { data } = await api.put(`/${orderID}`, updatedData)

        dispatch(updateOrderSuccess(data))
    } catch (error) {
        dispatch(updateOrderFail(
            error.message && error.response.data.detail ?
            error.response.data.detail :
            error.message
        ))
    }
}


export const confirmedList = (status=undefined, keyword=undefined) => async (dispatch) => {

    try {
        dispatch(confirmedOrderListRequest())

        const api = createAPIinstance()
        const { data } = await api.get('/buyer/', {
            params: {
                'isDelivered': status,
                'search': keyword
            }
        })

        dispatch(confirmedOrderListSuccess(data))
    } catch (error) {
        dispatch(confirmedOrderListFail(
            error.response && error.response.data.detail ?
            error.response.data.detail :
            error.message
        ))
    }

}


export const orderDetail = (id) => async (dispatch) => {

    try {
        dispatch(orderDetailRequest())

        const api = createAPIinstance()
        const { data } = await api.get(`/${id}`)

        dispatch(orderDetailSuccess(data))
    } catch (error) {
        dispatch(orderDetailFail(
            error.response && error.response.data.detail ?
            error.response.data.detail :
            error.message
        ))
    }

}
